import React from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

const StringFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath, label }) => {
  const { control } = useFormContext();
  return (
    <FormTextField
      size="small"
      label={label}
      name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}`}
      control={control}
    />
  );
};

export default StringFormFields;
